import request from '@/helpers/request'

export default {
  async index() {
    return await request.get('favorite')
  },
  async addClassFavorite(id) {
    return await request.get('favorite/class/' + id)
  },
  // async cancelClassFavorite(id) {
  //   return await request.get('unfavorite/class/' + id)
  // },
  async addInstructorFavorite(id) {
    return await request.get('favorite/instructor/' + id)
  },
  // async cancelInstructorFavorite(id) {
  //   return await request.get('unfavorite/instructor/' + id)
  // },
  async addCategoryFavorite(id) {
    return await request.get('favorite/category/' + id)
  }
}
